/**
 * TeacherSettingsContext
 *
 * Context for teacher settings sync state.
 */

import { createContext } from 'react';
import type { UseTeacherSettingsResult } from '@/hooks/useTeacherSettings';

/**
 * Context for teacher settings sync state
 */
export const TeacherSettingsContext = createContext<UseTeacherSettingsResult | null>(null);
